import cinema from '../assets/cinema.png';
import comedie from '../assets/comedie.png';
import divers from '../assets/divers.png';
import expositions from '../assets/expositions.png';
import theatre from '../assets/theatre.png';
import gastronomie from '../assets/gastronomie.png';
import litterature from '../assets/litterature.png';
import musique from '../assets/musique.png';
import famille from '../assets/famille.png';
import soirees from '../assets/soirees.png';
import sport from '../assets/sport.png';
import communaute from '../assets/communaute.png';
import gratuit from '../assets/gratuit.png';
import toutes from '../assets/toutes.png';
import type { AdminCategoryOption } from '../admin/types';

export const ADMIN_CATEGORY_OPTIONS: AdminCategoryOption[] = [
    { label: 'Litterature', name: 'Littérature', slug: 'litterature' },
    { label: 'Famille', name: 'Famille', slug: 'famille' },
    { label: 'Cinema', name: 'Cinéma', slug: 'cinema' },
    { label: 'Comedie', name: 'Comédie', slug: 'comedie' },
    { label: 'Expositions', name: 'Expositions', slug: 'expositions' },
    { label: 'Gastronomie', name: 'Gastronomie', slug: 'gastronomie' },
    { label: 'Musique', name: 'Musique', slug: 'musique' },
    { label: 'Theatre', name: 'Théâtre', slug: 'theatre' },
    { label: 'Sport', name: 'Sport', slug: 'sport' },
    { label: 'Communaute', name: 'Communauté', slug: 'communaute' },
    { label: 'Soirees', name: 'Soirées', slug: 'soirees' },
    { label: 'Divers', name: 'Divers', slug: 'divers' }
];

export const getIcon = (cat: string): string => {
    switch(cat) {
        case "cinema":
            return cinema;
        case "comedie":
            return comedie;
        case "divers":
            return divers;
        case "expositions":
            return expositions;
        case "theatre":
            return theatre;
        case "gastronomie":
            return gastronomie;
        case "litterature":
            return litterature;
        case "musique":
            return musique;
        case "famille":
            return famille;
        case "soirees":
            return soirees;
        case "sport":
            return sport;
        case "communaute":
            return communaute;
        case "gratuit":
            return gratuit;
        case "all":
            return toutes;
        default:
            return "";
        
    }
};
